import { useTranslation } from 'react-i18next';

import { QDivider, QText } from '@captivateiq/quotient';

import assistantI18n from '@captivateiq/assistant/i18n';

type AppActionLabelProps = {
  actionNames: string[];
};

export const AppActionLabel = ({ actionNames }: AppActionLabelProps) => {
  const { t } = useTranslation('assistant', { i18n: assistantI18n });

  const labels = actionNames
    .map((name) => {
      const key = `app_actions.${name}`;
      const label = t(key);
      // t() returns the key itself when no translation exists
      return label !== key ? label : null;
    })
    .filter(Boolean) as string[];

  if (labels.length === 0) {
    return null;
  }

  return (
    <>
      {labels.map((label) => (
        <QDivider key={label} sx={{ my: 0.5 }}>
          <QText color="text.secondary" variant="smallRegular">
            {label}
          </QText>
        </QDivider>
      ))}
    </>
  );
};
